
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getImageUrl } from '@mg/web-components/utils/image'
import { GtmEventTypes } from '~/utils/tracking/gtm'
import { gaMapping } from '~/utils/tracking/gtm/banners'
import { GQLBackgroundBanner } from '~/graphql/__generated__/interfaces'
import { ELEMENT_IDS } from '~/utils/elementIds'

const CONTAINER_WIDTH = '1460px'
const GTM_IN_VIEWPORT_WAIT_TIME = 1500

@Component
export default class TheBackgroundBanner extends Vue {
  @Prop({ required: true, type: Object }) backgroundBanner: GQLBackgroundBanner

  wrapperStyle = {
    backgroundColor: 'white',
    margin: '0 auto',
    maxWidth: CONTAINER_WIDTH,
  }

  render() {
    return null
  }

  @Watch('backgroundBanner.bannerId', { immediate: true })
  onBackgroundChange(bannerId: String) {
    if (bannerId) {
      this.modifyStyles(true)
      if (window.innerWidth > 1600) {
        setTimeout(() => {
          this.trackInternalPromoView()
        }, GTM_IN_VIEWPORT_WAIT_TIME)
      }
    }
  }

  get pageStyle() {
    return {
      ...(this.backgroundBanner.backgroundImage && {
        backgroundImage: `url('${getImageUrl(
          Number(this.backgroundBanner.backgroundImage)
        )}')`,
      }),
      backgroundColor: 'transparent',
      backgroundPosition: 'center top',
      backgroundRepeat: 'no-repeat',
    }
  }

  get containerStyle() {
    return {
      ...(this.backgroundBanner.skyscraperImage && {
        backgroundImage: `url('${getImageUrl(
          Number(this.backgroundBanner.skyscraperImage)
        )}')`,
      }),
      backgroundColor: this.backgroundBanner.backgroundColor || 'transparent',
      backgroundPosition: 'center top',
    }
  }

  get analyticsObject() {
    return {
      bannerId: this.backgroundBanner.bannerId,
      creative: this.backgroundBanner.gaTag ?? this.backgroundBanner.bannerId,
      name: gaMapping.BackgroundBanner,
      position: null,
    }
  }

  modifyStyles(setStyles: Boolean) {
    const layoutEl = document.getElementById(ELEMENT_IDS.LAYOUT) as HTMLElement
    const templateEl = document.getElementById(
      ELEMENT_IDS.MAIN_TEMPLATE
    ) as HTMLElement
    const pageEl = document.getElementById(
      ELEMENT_IDS.PAGE_CONTENT
    ) as HTMLElement
    if (setStyles) {
      this.setElementStyles(layoutEl, this.containerStyle)
      this.setElementStyles(templateEl, this.pageStyle)
      this.setElementStyles(pageEl, this.wrapperStyle)
      if (this.backgroundBanner.url && templateEl) {
        templateEl.addEventListener('click', this.onBackgroundBannerClick)
      }
    } else {
      this.unsetElementStyles(layoutEl)
      this.unsetElementStyles(templateEl)
      this.unsetElementStyles(pageEl)
    }
  }

  setElementStyles(el: HTMLElement, styleObject: { [key: string]: string }) {
    if (!el) {
      return
    }
    Object.keys(styleObject).forEach((item) => {
      // @ts-ignore
      el.style[item] = styleObject[item]
    })
  }

  unsetElementStyles(el: HTMLElement) {
    if (!el) {
      return
    }
    el.removeAttribute('style')
  }

  onBackgroundBannerClick(event: Event) {
    if ((event?.target as HTMLElement)?.id === 'main-template') {
      this.trackInternalPromoClick()
      const path = `/${this.backgroundBanner.url!.replace(/^\//g, '')}`
      if (this.backgroundBanner.urlNewWindow) {
        window.open(
          path,
          this.backgroundBanner.urlNewWindow ? '_blank' : '_self'
        )
      } else {
        this.$router.push({
          path,
        })
      }
    }
  }

  trackInternalPromoClick() {
    this.$pushAnalyticsEvent(GtmEventTypes.BannerClick, this.analyticsObject)
  }

  trackInternalPromoView() {
    this.$pushAnalyticsEvent(
      GtmEventTypes.BannerImpression,
      this.analyticsObject
    )
  }

  beforeDestroy() {
    this.modifyStyles(false)
  }
}
